export enum IrembogovSortDirectionsEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}
